//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sync } from 'vuex-pathify'
import { gql } from 'graphql-tag'
import { Language, ContentType } from '@constants'
import { slugify } from '../../utils'

const NAVBAR_ITEMS = gql`
  query {
    navbarItems(where: { isActive: { eq: true }, parentId: { eq: null } }, order: [{ order: ASC }]) {
      nodes {
        id
        name
        path
        hasPath
        languageId
        contentCollectionId
        contentCollection {
          slug
        }
        contentTypeId
        contentType {
          name
        }
        regionId
        region {
          name
        }
        countryId
        country {
          name
        }
        hasChildren
        children(where: { isActive: { eq: true } }, order: [{ order: ASC }]) {
          id
          name
          path
          hasPath
          languageId
          contentCollectionId
          contentCollection {
            slug
          }
          contentTypeId
          contentType {
            name
          }
          regionId
          region {
            name
          }
          countryId
          country {
            name
          }
        }
      }
    }
  }
`

const colours = Object.freeze(['danger', 'info', 'warning', ''])

export default {
  name: 'Menu',
  data() {
    return {
      ContentType,
      open: false,
      contentCollections: [],
      navbarItems: []
    }
  },
  fetchOnServer: true,
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    await this.fetchNavbarItems()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  computed: {
    filters: sync('filters'),
    navbar: sync('navbar'),
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    languages() {
      return this.$store.get('language/locales')
    },
    navbarItemsInCurrentLanguage() {
      return this.navbarItems.filter((x) => x.languageId === this.languageId)
    },
    colours() {
      return colours
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    onNavigate(navbarItem) {
      if (!this.getPath(navbarItem)) {
        return
      }

      this.setFilterOptions({
        contentCollectionId: navbarItem.contentCollectionId,
        contentTypeId: navbarItem.contentTypeId,
        regionId: navbarItem.regionId,
        countryId: navbarItem.countryId
      })

      if (navbarItem.contentCollection || navbarItem.contentType || navbarItem.region || navbarItem.country) {
        this.$store.set('navbar/selectedHeader', navbarItem.name)
      }

      if (!navbarItem.path || navbarItem.path.indexOf('/') === 0) {
        this.$router.push({ path: this.getPath(navbarItem) })
      } else window.location.href = this.getPath(navbarItem)

      this.open = false
    },
    getPath(navbarItem) {
      if (navbarItem.contentCollection) {
        return `/${navbarItem.contentCollection.slug}`
      } else if (navbarItem.contentType) {
        return `/${slugify(navbarItem.contentType.name)}`
      } else if (navbarItem.region) {
        return `/${slugify(navbarItem.region.name)}`
      } else if (navbarItem.country) {
        return `/${slugify(navbarItem.country.name)}`
      }

      return navbarItem.path
    },
    onLanguageSelect(language) {
      this.$root.$i18n.setLocale(language.code)
      this.$dayjs.locale(language.code)
      this.$store.set('language/locale', language.code)

      this.$nuxt.$emit('language-change', language)
    },
    async fetchNavbarItems() {
      try {
        const { data } = await this.$apollo.query({
          query: NAVBAR_ITEMS,
          fetchPolicy: 'network-only'
        })

        this.navbarItems = data.navbarItems.nodes
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
